// extracted by mini-css-extract-plugin
export default {"footer-button":"footer-button--FRTFg","footer-button__icon":"footer-button__icon--11F8M","footer-button__icon--no-commented":"footer-button__icon--no-commented--31Xf1"};
    if(module.hot) {
      // 1744795048148
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  